module.exports = __webpack_public_path__ + "img/next-expo.b5ed597f.svg";